type AnalyticsDataSectionProps = {
  badge: string;
  badgeColor: string;
  label: string;
  subtitle?: string | number;
  value?: string | number;
  gapClassName?: string;
};

export const AnalyticsDataSection = ({
  badge,
  badgeColor,
  label,
  subtitle,
  value,
  gapClassName = "gap-1",
}: AnalyticsDataSectionProps) => {
  return (
    <div className={`bg-white border border-gray-200 rounded-lg p-4 flex flex-col ${gapClassName} shadow-sm`}>
      <div className="flex items-start justify-between">
        <span className={`${badgeColor} text-white text-xs font-bold px-2 py-0.5 rounded-full uppercase`}>
          {badge}
        </span>
      </div>
      <p className="text-xl font-bold text-gray-900 leading-tight">{subtitle ?? value}</p>
      <p className="text-xs font-medium text-gray-900">{label}</p>
    </div>
  );
};
